<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-10">
      <!-- begin col-4 -->
      <div class="col-xl-6 col-lg-6">
        <!-- begin card -->
        <div
          class="card border-0 mb-3"
          :class="{ 'bg-dark-darker text-white': inverseMode }"
        >
          <!-- begin card-body -->
          <div class="card-body">
            <!-- begin title -->
            <div class="mb-3 text-grey">
              <b>CUSTOMER INVOICE STATISTIC</b>
              <span class="text-grey ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Customer Invoice Statistic"
                  v-b-popover.hover="
                    'Total online store sales that came from a social referrer source.'
                  "
                ></i
              ></span>
            </div>
            <!-- end title -->
            <!-- begin sales -->
            <h3
              class="m-b-10"
              :class="inverseMode ? 'text-white' : 'ts-text-gray-700'"
            >
              ${{ totalAmount | format_number }}
            </h3>
            <!-- end sales -->
            <!-- begin percentage -->
            <div class="text-grey m-b-1">
              <i class="fa fa-caret-up"></i> {{ totalQuantity }}
            </div>
            <!-- end percentage -->
          </div>
          <!-- end card-body -->
          <!-- begin widget-list -->
          <div
            class="widget-list widget-list-rounded"
            :class="{ 'inverse-mode': inverseMode }"
          >
            <!-- begin widget-list-item -->
            <a
              class="widget-list-item rounded-0 p-t-3"
              v-for="(record, index) in resources"
              :key="index"
            >
              <div class="widget-list-media icon">
                <i :class="icon[index]"></i>
              </div>
              <div class="widget-list-content">
                <div class="widget-list-title">{{ record.invoice_status }}</div>
              </div>
              <div class="widget-list-action text-nowrap text-grey">
                {{ record.invoice_quantity }}
              </div>
              <div class="widget-list-action"></div>
              <div class="widget-list-action widget-list-title">
                ${{ record.amount | format_number }}
              </div>
            </a>
            <!-- end widget-list-item -->
          </div>
          <!-- end widget-list -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col-4 -->
      <!-- begin col-4 -->
      <div class="col-xl-6 col-lg-6">
        <!-- begin card -->
        <div
          class="card border-0 mb-3"
          :class="{ 'bg-dark-darker text-white': inverseMode }"
        >
          <!-- begin card-body -->
          <div class="card-body">
            <!-- begin title -->
            <div class="mb-3 text-grey">
              <b>VENDOR INVOICE STATISTIC</b>
              <span class="text-grey ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Vendor Invoice Statistic"
                  v-b-popover.hover="
                    'Total online store sales that came from a social referrer source.'
                  "
                ></i
              ></span>
            </div>
            <!-- end title -->
            <!-- begin sales -->
            <h3
              class="m-b-10"
              :class="inverseMode ? 'text-white' : 'ts-text-gray-700'"
            >
              ${{ vendorTotalAmount | format_number }}
            </h3>
            <!-- end sales -->
            <!-- begin percentage -->
            <div class="text-grey m-b-1">
              <i class="fa fa-caret-up"></i> {{ vendorTotalQuantity }}
            </div>
            <!-- end percentage -->
          </div>
          <!-- end card-body -->
          <!-- begin widget-list -->
          <div
            class="widget-list widget-list-rounded"
            :class="{ 'inverse-mode': inverseMode }"
          >
            <!-- begin widget-list-item -->
            <a
              class="widget-list-item rounded-0 p-t-3"
              v-for="(record, index) in vendorInvoiceResources"
              :key="index"
            >
              <div class="widget-list-media icon">
                <i :class="icon[index]"></i>
              </div>
              <div class="widget-list-content">
                <div class="widget-list-title">{{ record.invoice_status }}</div>
              </div>
              <div class="widget-list-action text-nowrap text-grey">
                {{ record.invoice_quantity }}
              </div>
              <div class="widget-list-action"></div>
              <div class="widget-list-action widget-list-title">
                ${{ record.amount | format_number }}
              </div>
            </a>
            <!-- end widget-list-item -->
          </div>
          <!-- end widget-list -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col-4 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  props: ['inverseMode'],
  data () {
    return {
      loading: false,
      resources: null,
      vendorInvoiceResources: null,
      icon: [
        'fas fa-file-invoice-dollar bg-success text-white',
        'fas fa-file-invoice bg-primary text-white',
        'fas fa-file-alt bg-danger text-white'
      ]
    }
  },
  filters: {
    format_number (value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return 0
    }
  },
  computed: {
    totalAmount () {
      if (this.resources) {
        return this.resources
          .map(o => o.amount)
          .reduce((a, c) => {
            return parseFloat(a) + parseFloat(c)
          })
      }
      return 0
    },
    totalQuantity () {
      if (this.resources) {
        return this.resources
          .map(o => o.invoice_quantity)
          .reduce((a, c) => {
            return parseFloat(a) + parseFloat(c)
          })
      }
      return 0
    },
    vendorTotalAmount () {
      if (this.vendorInvoiceResources) {
        return this.vendorInvoiceResources
          .map(o => o.amount)
          .reduce((a, c) => {
            return parseFloat(a) + parseFloat(c)
          })
      }
      return 0
    },
    vendorTotalQuantity () {
      if (this.vendorInvoiceResources) {
        return this.vendorInvoiceResources
          .map(o => o.invoice_quantity)
          .reduce((a, c) => {
            return parseFloat(a) + parseFloat(c)
          })
      }
      return 0
    }
  },
  methods: {
    ...mapActions('dashboard/widget', [
      'fetchCustomerInvoiceStatistic',
      'fetchVendorInvoiceStatistic'
    ]),
    moment,
    async fetchData () {
      this.loading = true
      await this.fetchCustomerInvoiceStatistic()
        .then(responses => {
          this.resources = responses
        })
        .catch(() => {
          // this.$toasted.error(error.message)
          this.loading = false
        })
      this.fetchVendorInvoiceStatistic()
        .then(responses => {
          this.vendorInvoiceResources = responses
          this.loading = false
        })
        .catch(() => {
          // this.$toasted.error(error.message)
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.bg-dark-darker {
  background-color: #22282d !important;
}
</style>
